/** Same UTF-16, signed 32-bit hash used by the shared Avatar. */
export const avatarPalette = [
  ['orange.500', '#f97316'],
  ['yellow.400', '#e49c06'],
  ['red.400', '#f87171'],
  ['green.500', '#22c55e'],
  ['teal.500', '#14b8a6'],
  ['pink.500', '#ec4899'],
  ['cyan.600', '#0891b2'],
] as const;

const paletteIndex = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
  return Math.abs(hash) % avatarPalette.length;
};

export const pickAvatarPalette = (name: string) => avatarPalette[paletteIndex(name)][0];

/** Hex wire representation for native surfaces; source images use brand.600. */
export const avatarFallbackHex = (name?: string | null, src?: string | null) =>
  !src && name ? avatarPalette[paletteIndex(name)][1] : '#2d2f39';
